"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseGenericRssXml = parseGenericRssXml;
const fast_xml_parser_1 = require("fast-xml-parser");
const parser = new fast_xml_parser_1.XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    parseAttributeValue: false,
    parseTagValue: false,
    trimValues: true,
    isArray: (name) => name === "item",
});
function parseGenericRssXml(xml) {
    const parsedFeed = parser.parse(xml);
    const channel = parsedFeed?.rss?.channel ??
        parsedFeed?.feed ??
        parsedFeed?.rdf?.channel;
    if (!channel || typeof channel !== "object") {
        throw new Error("Unrecognized RSS / Atom channel");
    }
    const ch = channel;
    const { title, description, item } = ch;
    const rawList = Array.isArray(item) ? item : item ? [item] : [];
    const items = rawList.filter((x) => x != null && typeof x === "object");
    return { title, description, items };
}
